export default "__VITE_ASSET__C779S6NU__"